import TeamComponent from "@/components/team";

export default function Team() {
  return <TeamComponent />;
}
